import { Block } from '$views/components'
import * as React from 'react'
import spinnerIcon from '$icons/Spinner.svg'
import { Icon } from '$views/components/Icon'

interface Props {
  onLoadMoreData: () => Promise<void>
}

export const InfiniteScrollLoader: React.FC<Props> = ({ onLoadMoreData }) => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const loadMoreDataRef = React.useRef(onLoadMoreData)

  React.useEffect(() => {
    loadMoreDataRef.current = onLoadMoreData
  }, [onLoadMoreData])

  React.useEffect(() => {
    const loadData = async () => {
      if (loading) {
        await loadMoreDataRef.current()
        setLoading(false)
      }
    }

    loadData()
  }, [loading])

  React.useEffect(() => {
    window.addEventListener('scroll', async () => {
      if (Math.ceil(window.scrollY) + window.innerHeight >= document.body.scrollHeight) {
        setLoading(true)
      }
    })
  }, [])

  return (
    <Block flex alignItems="center" justify="center">
      {loading && <Icon testId="spinner" content={spinnerIcon} size="xl" />}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/CaretakerList/components/InfiniteScrollLoader/InfiniteScrollLoader.tsx